import { email } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function createEmail({ url: { service: baseURL }, token }: IAPI) {
  return (email: email.CreateEmail): Promise<email.Email> =>
    send({
      baseURL,
      token,
      path: `/email-communication`,
      method: 'POST',
      body: email,
    });
}

export interface Emails {
  Items: email.Email[];
}

export function findEmails({ url: { service: baseURL }, token }: IAPI) {
  return (applicationID: string | undefined): Promise<Emails> =>
    send({
      baseURL,
      token,
      path: `/email-communication?loanApplicationID=${applicationID}`,
      method: 'GET',
    });
}
